import { Component, OnInit } from '@angular/core';
import { urlJoin } from 'src/app/core/common/public';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  gotoPage(link: string) {
    window.location.href = urlJoin(environment.djangoUrl, link);
  }
}
